
'use strict';

import {Injectable, Inject} from 'ng-metadata/core';
import {TemplateUtil} from '../../../nddUtils/templateUtil.service';
import {getVid, getUrlContext} from '../../../appConfig/appConfigForward';
const flatten = require('lodash/flatten');
import {PrimoResponse} from '../../../infra/dataStructures/PrimoResponses/doc.interfcae';
import {isBrowserSafari} from "../../../infra/browserSniffer";
import {SearchStateService} from '../../searchState.service';
import {ConfigurationUtil} from "../../../nddUtils/configurationUtil.service";
const _get = require('lodash/get');

@Injectable()
export class PrintItemService {
    private vid = getVid();
    private PRINT_API_URL: string;
    constructor(private templateUtil: TemplateUtil,
                private searchStateService : SearchStateService,
                private configurationUtil: ConfigurationUtil,
                @Inject('$http') private $http: ng.IHttpService,
                @Inject('restBaseURLs') private restBaseURLs,
                @Inject('$state') private $state: angular.ui.IStateService, 
                @Inject('$translate') private $translate: ng.translate.ITranslateService) {
        this.PRINT_API_URL= restBaseURLs.actionsBaseURL+'/print'+'?vid=' + this.vid ;
    }
    public printItemAction(item, selectedIds){
        let popupWin = window.open('', '_blank');
        this.getPrintHtml([item], selectedIds).then(
            (response:{data:{html:string}}) => {

                let printContent = response.data.html;
                if (!printContent) {
                    popupWin.close();
                    return;
                }
                let content = '';
                if (isBrowserSafari()) { //if we are in safari don't close window after window.print since it closes window immediately
                    content = '<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print();" dir=' + document.dir + '>' + printContent + '</body>' + '</html>';
                } else {
                    content ='<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print();window.close();" dir=' + document.dir + '>' + printContent + '</body>' + '</html>';
                }
                if(popupWin.paramsOfWin) {
                    //this will get overridden and handled in campusm (see cm_integrations.ts)
                    window.open(content, "_print") ;
                }else{
                    popupWin.document.open();

                    popupWin.document.write(content);

                    popupWin.document.close();
                }

            });
    }

     public getPrintHtml(items, selectedIds) {
        //TODO: call rest api to get html content to print
        let payload = this.buildPayload(flatten(items), selectedIds);
        return this.$http.post(this.PRINT_API_URL, payload);
    }


   private itemToRecord(item: PrimoResponse.IDoc) {
       //TODO: these parameters should not be hardcoded
        let record = {
            pnx:item.pnx,
            context: this.getContext(item),
            holdings: _get(item,'delivery.holding',[]),
            deeplink: this.templateUtil.getDeepLinkAbsPath(item),
            link2online:[]
        };


        return record;
    }

    private buildPayload(items, selectedIds: any) {
        let records= selectedIds ? selectedIds: items.map((item)=>this.itemToRecord(item));
        let payload= {
        
                "records":selectedIds ? selectedIds: items.map((item)=>this.itemToRecord(item)),
                "vid": this.vid,
                "language": this.$translate.use(),
                
        };
         if (selectedIds) {
            payload.additionalParams = {
                    state: this.$state.current.name,
                    href: window.location.href,
                    searchScope: this.$state.params['search_scope'] || this.searchStateService.getSearchObject().scope,
                    adaptor: this.$state.params['adaptor'],
                    baseUrl: this.templateUtil.getBaseUrl(),
                    urlContext: getUrlContext(),
                    curState: this.templateUtil.getCurState()
            } 
         }
        return payload;
    }

    private getContext(item) {
        let recordId = item.pnx.control.recordid[0];
        let context = item.context;
        if (context === undefined){
            if (recordId.startsWith("TN_")) {
                context = "PC";
            }
            else {
                context = "L";
            }
        }
        return context;

    }




}

export default['nddUtils'];


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/printAction/printItem.service.ts